import React from 'react'
import { useForm } from 'react-hook-form'
import { useWindowSize } from '@react-hook/window-size/throttled'
import { useLogin, AuthErrors } from './use-login'
import { RECOVER_PASSWORD, REGISTER } from 'routes'
import { InputPassword, Button, LogoIcon, InputEmail } from 'ui'
import {
  Container,
  LogoColumn,
  FormColumn,
  FormContent,
  MainTitle,
  Form,
  LinkForgotPassword,
  LinkRegister,
  LoginOptions,
  Register,
  SpacedSpinner,
  FormErrorMessage,
  LogoColumnContent,
  PasswordExpiredMessage,
} from './components'

import { errorMessages } from 'resources'
import { Link } from 'react-router-dom'

const Login = () => {
  const [width] = useWindowSize()

  const { register, errors, handleSubmit } = useForm()
  const { handleSubmit: onSubmit, isLogging, error } = useLogin()

  const logoWidth = width >= 900 ? '60px' : '40px'
  const isLogoWhite = width >= 900

  return (
    <Container>
      <LogoColumn>
        <LogoColumnContent>
          <LogoIcon
            as='span'
            white={isLogoWhite}
            width={logoWidth}
          />
        </LogoColumnContent>
      </LogoColumn>
      <FormColumn>
        <FormContent>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <MainTitle>Faça seu login</MainTitle>
            <InputEmail
              autoFocus
              name='email'
              id='email'
              label='E-mail'
              inputRef={register}
              error={errors.email}
              required
            />
            <InputPassword
              name='password'
              id='password'
              label='Senha'
              inputRef={register({ required: true })}
              error={errors.password}
            />

            {error === AuthErrors.INVALID_LOGIN && <FormErrorMessage>{errorMessages.LOGIN_ERROR} </FormErrorMessage>}
            {error === AuthErrors.PASSWORD_EXPIRED && <PasswordExpiredMessage>Você precisa ativar o seu cadastro. <Link to={RECOVER_PASSWORD}>Clique aqui</Link> para criar uma nova senha.</PasswordExpiredMessage>}
            <LoginOptions>
              <Button as='button' disabled={isLogging}>Entrar</Button>
              {isLogging && <SpacedSpinner size='30px' />}

              <LinkForgotPassword to={RECOVER_PASSWORD} variant='clear'>Esqueci minha senha</LinkForgotPassword>
            </LoginOptions>
          </Form>
          <Register>
            Não tem uma conta? <LinkRegister to={REGISTER}>Cadastre-se</LinkRegister>
          </Register>
        </FormContent>
      </FormColumn>
    </Container>
  )
}

export default Login
